var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvitation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 23.7942C15.9999 22.1942 17.0666 21.1275 18.6666 21.1275H37.3333L47.9999 31.7942V34.9942L58.6666 26.4608L33.5999 6.46084C32.5333 5.66084 31.1999 5.66084 30.3999 6.46084L5.33325 26.4608L15.9999 34.9942V23.7942Z",
    fill: "#2563EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M58.6666 26.4608V55.7942C58.6666 57.3942 57.5999 58.4608 55.9999 58.4608H7.99992C6.39992 58.4608 5.33325 57.3942 5.33325 55.7942V26.4608L30.3999 46.4608C31.4666 47.2608 32.7999 47.2608 33.5999 46.4608L58.6666 26.4608ZM39.9999 31.7942H47.9999L37.3333 21.1274V29.1275C37.3333 30.7275 38.3999 31.7942 39.9999 31.7942Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitation);
export default __webpack_public_path__ + "static/media/invitation.6c81129c83637de92a4fa41606055f24.svg";
export { ForwardRef as ReactComponent };